import { FC } from 'react';

import { IconProps } from '.';

export const PngFileIcon: FC<IconProps> = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 3.334v25.333a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V8.242a1 1 0 0 0-.264-.677l-5.439-5.909a1 1 0 0 0-.736-.322H7.5a2 2 0 0 0-2 2"
      fill="#FED7AA"
    />
    <path
      d="M27 18.61H4v8.657a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V19.61a1 1 0 0 0-1-1"
      fill="#FFAE51"
    />
    <path d="M5.5 17 4 18.61h1.5z" fill="#99672E" />
    <path
      d="M9.013 26v-5.09h1.91q.586 0 .984.218.4.22.604.602.206.38.206.865 0 .489-.206.87-.206.38-.61.6-.402.215-.991.215H9.645v-.758h1.14q.345 0 .563-.12a.75.75 0 0 0 .323-.327q.106-.21.107-.48 0-.27-.107-.477a.73.73 0 0 0-.326-.321 1.2 1.2 0 0 0-.564-.117h-.845V26zm8.689-5.09V26h-.82l-2.4-3.467h-.041V26h-.923v-5.09h.825l2.397 3.47h.045v-3.47zm4.415 1.625a1.3 1.3 0 0 0-.171-.36 1.1 1.1 0 0 0-.259-.276 1 1 0 0 0-.343-.172 1.4 1.4 0 0 0-.422-.06 1.3 1.3 0 0 0-.731.207q-.32.207-.505.607-.18.397-.181.97 0 .576.181.976.182.4.505.609.323.206.75.206.389 0 .672-.149.285-.15.44-.422.153-.276.154-.647l.209.033h-1.383v-.721H23.1v.611q0 .654-.278 1.131-.279.477-.766.736a2.4 2.4 0 0 1-1.119.256q-.702 0-1.235-.316a2.2 2.2 0 0 1-.828-.902q-.296-.587-.296-1.392 0-.617.174-1.101a2.4 2.4 0 0 1 .493-.823q.315-.341.74-.517.426-.18.925-.179.422 0 .788.124.366.123.649.348.285.226.47.537.184.31.24.686zM12.111 17q-.458 0-.792-.32a1.1 1.1 0 0 1-.319-.79V8.11q0-.458.32-.778.332-.332.79-.332h7.778q.458 0 .778.333.333.32.333.778v7.778q0 .458-.333.792-.32.318-.778.319zm0-1.111h7.778V8.11H12.11zm.556-1.111h6.666L17.25 12l-1.667 2.222-1.25-1.666zm-.556 1.11V8.112z"
      fill="#fff"
    />
  </svg>
);
